// extracted by mini-css-extract-plugin
export default {"container":"ComingSoon_container__0hIM1","stage":"ComingSoon_stage__B7dl-","dot-flashing":"ComingSoon_dot-flashing__zXqTs","dotFlashing":"ComingSoon_dotFlashing__nSzZp"};